import { noop } from 'utils/helpers.util';
import * as S from './PaymentRadioCard.style';
import Card from 'common/Card';

const PaymentRadioCard: React.FC<{
  checked?: boolean;
  value: any;
  header: React.ReactElement | string;
  testid: string;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  children?: React.ReactElement;
}> = ({ checked, children, disabled, header, value, testid, onChange = noop, onClick = noop }) => {
  return (
    <Card testId={`${testid}-card`}>
      <S.Label data-testid={testid}>
        <S.RadioButton
          type="radio"
          name="paymentMode"
          checked={checked}
          disabled={disabled}
          value={value}
          onChange={onChange}
          onClick={onClick}
        />
        {header}
      </S.Label>

      {/* Render children on radio selected */}
      {checked ? children : null}
    </Card>
  );
};

export default PaymentRadioCard;
